import React, { createContext } from "react";

import { PrivateLayoutContextType } from "./types";
import { defaultPrivateLayoutContextValue } from "./consts";

export const PrivateLayoutContext = createContext<PrivateLayoutContextType>(defaultPrivateLayoutContextValue);
